import { X } from 'lucide-react';
import { useTheme } from '../../../contexts/ThemeContext';

interface SidebarHeaderProps {
  onMenuClick: () => void;
  isSidebarExpanded: boolean;
}

export default function SidebarHeader({ onMenuClick, isSidebarExpanded }: SidebarHeaderProps) {
  const { density } = useTheme();

  return (
    <div className='flex justify-end mt-3 mr-3 px-3'>
      <div className={`md:hidden cursor-pointer`} onClick={onMenuClick}>
        <X className='h-6 w-6 text-gray-600 dark:text-darkBg-subText' />
      </div>
    </div>
  );
}
